import type {ReactElement} from 'react';
import {useState} from 'react';
import type {AITextToImageBackendData} from '@Libraries/pmw-stock-media-library';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import {GridItemTag} from '../grid-item-tag/grid-item-tag';
import type {GridMediaItemStorage, GridMediaItemTag} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import type {GRID_ITEM_TYPE, GridItemProps} from '../grid-item';
import styles from './grid-stock-image-item.module.scss';

export interface GridStockImageItemStorage extends GridMediaItemStorage {
  type: GRID_ITEM_TYPE.STOCK_IMAGE;
  thumbSrc: string;
  source: string;
  data: Record<string, any>;
}

export interface GridAiImageItemStorage extends GridStockImageItemStorage {
  highResSrc: string;
  topRightContent?: ReactElement;
  backendData?: AITextToImageBackendData;
}

export type GridStockImageItemBackEndData = Record<string, any>;

interface GridStockImageItemProps extends GridItemProps {
  thumbSrc: string;
  paddedThumb?: boolean;
  isLoading?: boolean;
  tag?: GridMediaItemTag;
}

export function GridStockImageItem({...props}: GridStockImageItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      hasGrayBackground={hasGrayBackground}
      thumb={
        <div>
          <img
            onLoad={(): void => {
              setIsImageLoaded(true);
              void isStockItemPredominantlyWhite(props.thumbSrc).then(setHasGrayBackground);
            }}
            src={props.thumbSrc}
            className={`radius-12 ${styles.thumb}`}
            alt={window.i18next.t('pmwjs_image')}
            draggable="false"
            loading="lazy"
            onContextMenu={(e): void => {
              e.preventDefault();
            }}
          />
          <GridItemTag tag={props.tag} />
        </div>
      }
    />
  );
}
